import "./Intelligence.module.css";
import Header from "@/reusable_sections/Header";
import TheLaunchpad from "./sections/TheLaunchpad";
import InnovationPhilosophy from "./sections/InnovationPhilosophy";
import IndustryVerticals from "./sections/IndustryVerticals";
import ActiveInnovationOceanProtocol from "./sections/ActiveInnovationOceanProtocol";
import SolutionPartners from "./sections/SolutionPartners";
import ReserveYourJourney from "./sections/ReserveYourJourney";
import Footer from "@/reusable_sections/Footer";
export default function IntelligencePage() {
  return <div>
      <Header />
      <TheLaunchpad />
      <InnovationPhilosophy />
      <IndustryVerticals />
      <ActiveInnovationOceanProtocol />
      <SolutionPartners />
      <ReserveYourJourney />
      <Footer />
    </div>;
}